import React, { useEffect } from "react";
import { LuCheck } from "react-icons/lu";
import { FaTimes } from "react-icons/fa";

const Modal = ({ isShown, type, message, onClose }) => {
  useEffect(() => {
    if (isShown) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [isShown, onClose]);

  // if (!isShown) return null;
  return (
    <div
      className={`absolute top-2 lg:top-14 right-2 transition-all duration-500 z-[500] max-w-[90%] ${
        isShown ? "opacity-100 translate-x-[0px]" : "opacity-0 translate-x-[900px]"
      }`}
    >
      <div
        className={`min-w-52 bg-white border shadow-2xl rounded-md after:w-[5px] after:h-full ${
          type === "error" ? "after:bg-red-500" : "after:bg-green-500"
        } after:absolute after:left-0 after:top-0 after:rounded-l-lg`}
      >
        <div className={"flex items-center gap-3 py-2 px-4"}>
          <div
            className={`w-10 h-10 flex items-center justify-center rounded-full ${
              type === "error" ? "bg-red-50" : "bg-green-50"
            }`}
          >
            {type === "error" ? (
              <FaTimes className="md:text-xl text-red-500" />
            ) : (
              <LuCheck className="md:text-xl text-green-500" />
            )}
          </div>
          <p className="text-sm 2xl:text-md md:font-medium text-slate-800 text-wrap">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default Modal;
